import { render, staticRenderFns } from "./draggable-list.vue?vue&type=template&id=71727a0a&"
import script from "./draggable-list.vue?vue&type=script&lang=js&"
export * from "./draggable-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports